import { CloseIllustration, Flex, PrimaryButton, SmartLink, Text } from '@stashinvest/ui';
import React from 'react';
import { BanjoString } from '@stashinvest/react-banjo';

export const ReauthError = ({ error }) => {
	return (
		<>
			<Flex alignItems="center" flexDirection="column">
				<CloseIllustration height="6rem" mb="s" />
			</Flex>
			<Text.H3 as="h1" mb="s" align="center">
				We’re unable to pause your recurring transactions
			</Text.H3>
			<Text mb="s" align="center">
				{error?.errors?.[0]?.message || (
					<BanjoString
						stringId={'information/giveContext/pauseRecurringTransactionsError'}
					/>
				)}
			</Text>
			<PrimaryButton as={SmartLink} to="/auto-stash">
				<BanjoString stringId="action/progress/dismissInformation" />
			</PrimaryButton>
		</>
	);
};
